import React from 'react';
import { connect } from 'react-redux';
import { getIsPromisePending } from '../../pending-promises/selectors';
import { getAllLoadingPromises } from '../selectors';

// Wraps component and gives it access to whethere there are ANY loading promises pending
export const isLoading = ComposedComponent => props => {
  return <ComposedComponent {...props} />;
};

const mapStateToProps = state => {
  const promises = getAllLoadingPromises(state);
  return {
    isLoading: getIsPromisePending(state, { promises }),
  };
};

export default (...args) => connect(mapStateToProps)(isLoading(...args));



// WEBPACK FOOTER //
// ./src/redux-modules/loading-overlay/components/isLoading.js